import * as React from 'react';
import { PhoneButton } from '../../components/PhoneButton';
import { useSelector } from 'react-redux';
import { selectBuilderPhone } from '../../selectors';

export interface IPhoneButtonContainerProps {
  button?: React.ReactNode;
  contentRenderer: (phone: string) => React.ReactNode;
  onShow?(): void;
}

export const PhoneButtonContainer: React.FC<IPhoneButtonContainerProps> = ({ button, contentRenderer, onShow }) => {
  const [phoneVisible, setPhoneVisible] = React.useState(false);
  const phone = useSelector(selectBuilderPhone);

  const handleShowPhone = React.useCallback(() => {
    setPhoneVisible(true);

    /* istanbul ignore next */
    if (onShow) {
      onShow();
    }
  }, [onShow]);

  if (!phone) {
    return null;
  }

  return (
    <PhoneButton
      button={button}
      content={contentRenderer(phone)}
      phoneVisible={phoneVisible}
      onShow={handleShowPhone}
    />
  );
};
